module.exports = __webpack_public_path__ + "img/visionaries-card-three-mobile.9c113bf4.png";